import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // SPD-27133: pending backend design decision (Option A vs B); update string if backend uses a different value
  quoted: {
    description: 'salesOrderStatus.quoted — freight pre-booking state before carrier booking is confirmed',
    defaultMessage: 'Quoted',
    id: 'i04Am1',
  },
  awaitingPayment: {
    description: 'salesOrderStatus.awaitingPayment',
    defaultMessage: 'Awaiting Payment',
    id: 'GdXcuK',
  },
  onHold: {
    description: 'salesOrderStatus.onHold',
    defaultMessage: 'On Hold',
    id: '0wOstF',
  },
  awaitingShipment: {
    description: 'salesOrderStatus.awaitingShipment',
    defaultMessage: 'Awaiting Shipment',
    id: 'lpYpCJ',
  },
  shipped: {
    description: 'salesOrderStatus.shipped',
    defaultMessage: 'Shipped',
    id: 'Uz9q59',
  },
  cancelled: {
    description: 'salesOrderStatus.cancelled',
    defaultMessage: 'Cancelled',
    id: 'CFfcvl',
  },
  pendingFulfillment: {
    description: 'salesOrderStatus.pendingFulfillment',
    defaultMessage: 'Pending Fulfillment',
    id: '4dj+6Q',
  },
  rejectedFulfillment: {
    description: 'salesOrderStatus.rejectedFulfillment',
    defaultMessage: 'Rejected Fulfillment',
    id: '3/41ea',
  },
  pendingPickup: {
    description: 'salesOrderStatus.pendingPickup',
    defaultMessage: 'Pending Pickup',
    id: 'uNX/OC',
  },
});

export const FulfillmentPlanOrderGridStatus = Object.freeze({
  Quoted: {
    name: 'Quoted',
    displayName: 'Quoted',
    translation: messages.quoted,
    pillTheme: 'quoted',
  },
  AwaitingPayment: {
    name: 'AwaitingPayment',
    displayName: 'Awaiting Payment',
    translation: messages.awaitingPayment,
    pillTheme: 'awaiting-payment',
  },
  OnHold: {
    name: 'OnHold',
    displayName: 'On Hold',
    translation: messages.onHold,
    pillTheme: 'on-hold',
  },
  AwaitingShipment: {
    name: 'AwaitingShipment',
    displayName: 'Awaiting Shipment',
    translation: messages.awaitingShipment,
    pillTheme: 'awaiting-shipment',
  },
  Shipped: {
    name: 'Shipped',
    displayName: 'Shipped',
    translation: messages.shipped,
    pillTheme: 'shipped',
  },
  Cancelled: {
    name: 'Cancelled',
    displayName: 'Cancelled',
    translation: messages.cancelled,
    pillTheme: 'cancelled',
  },
  PendingFulfillment: {
    name: 'PendingFulfillment',
    displayName: 'Pending Fulfillment',
    translation: messages.pendingFulfillment,
    pillTheme: 'pending-fulfillment',
  },
  RejectedFulfillment: {
    name: 'RejectedFulfillment',
    displayName: 'Rejected Fulfillment',
    translation: messages.rejectedFulfillment,
    pillTheme: 'rejected-fulfillment',
  },
  PendingPickup: {
    name: 'PendingPickup',
    displayName: 'Pending Pickup',
    translation: messages.pendingPickup,
    pillTheme: 'pending-pickup',
  },
});

export const EligibleToEditStatuses = [
  FulfillmentPlanOrderGridStatus.AwaitingPayment.name,
  FulfillmentPlanOrderGridStatus.AwaitingShipment.name,
  FulfillmentPlanOrderGridStatus.RejectedFulfillment.name,
  FulfillmentPlanOrderGridStatus.OnHold.name,
];

export const DELETABLE_STATUSES = [
  FulfillmentPlanOrderGridStatus.AwaitingShipment.name,
  FulfillmentPlanOrderGridStatus.AwaitingPayment.name,
  FulfillmentPlanOrderGridStatus.OnHold.name,
  FulfillmentPlanOrderGridStatus.Cancelled.name,
];

export const acceptableStatusesThatCanBePlacedOnHold = {
  [FulfillmentPlanOrderGridStatus.AwaitingPayment.name]: true,
  [FulfillmentPlanOrderGridStatus.AwaitingShipment.name]: true,
  [FulfillmentPlanOrderGridStatus.RejectedFulfillment.name]: true,
};
